import { APP_INVITATION_LIMIT } from '../../config/app-invitation.config';

import type { User } from '../../types/auth';

/**
 * Invitation Quota
 *
 * What is left of an account's app invitations and how each surface words it,
 * as pure functions shared by web and mobile. Spent invitations never come
 * back, so "left" is the limit less every one ever sent.
 */

/** Invitations the user can still send, never below 0. */
export function invitationsLeft(
  user: Pick<User, 'app_invitations_sent'> | null | undefined
): number {
  const sent = user?.app_invitations_sent ?? 0;
  return Math.max(0, APP_INVITATION_LIMIT - sent);
}

/** The dialog's quota line: "3 of 5 left", or "1 invitation left" for the last. */
export function describeInvitationsLeft(left: number): string {
  return left === 1
    ? '1 invitation left'
    : `${left} of ${APP_INVITATION_LIMIT} left`;
}

/** The profile menu row's meta: "3 left". */
export function describeInvitationsMeta(left: number): string {
  return `${left} left`;
}

/** One entry per invitation, in order; true for each one still to send. */
export function invitationPips(left: number): boolean[] {
  return Array.from(
    { length: APP_INVITATION_LIMIT },
    (_, index) => index < left
  );
}
